document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector(".main-search__input");
  if (!searchInput) return;

  // ---- 1. Track search results (after typing) ----
  let lastSearchTerm = "";
  let observer = new MutationObserver(() => {
    const container = document.querySelector(".main-search__results__products");
    if (!container) return;

    const productBlocks = container.querySelectorAll(".product-block");
    const searchTerm = searchInput.value.trim();

    if (searchTerm && searchTerm !== lastSearchTerm) {
      lastSearchTerm = searchTerm;

      const resultCount = productBlocks.length;
      const productTitles = [];
      const productUrls = [];

      productBlocks.forEach((block) => {
        const title = block.querySelector(".product-block__title")?.innerText.trim() || "";
        const url = block.querySelector("a")?.getAttribute("href") || "";
        if (title) productTitles.push(title);
        if (url) productUrls.push(url);
      });

      if (window.gtag) {
        gtag("event", "custom_search_results", {
          search_term: searchTerm,
          result_count: resultCount,
          product_titles: productTitles,
          product_urls: productUrls,
          source_page_url: window.location.href,
        });
        console.log("Event Tagged custom_search_results");
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // ---- 2. Track clicks on search results ----
  document.body.addEventListener("click", function (e) {
    const productBlock = e.target.closest(".product-block");
    if (productBlock && productBlock.querySelector("a")) {
      const link = productBlock.querySelector("a");
      const productTitle = productBlock.querySelector(".product-block__title")?.innerText.trim() || "";
      const productUrl = link.getAttribute("href");
      const position = [...productBlock.parentElement.children].indexOf(productBlock) + 1;
      const searchTerm = searchInput.value.trim();
      const sourcePageUrl = window.location.href;

      if (window.gtag) {
        gtag("event", "custom_search_click", {
          search_term: searchTerm,
          product_title: productTitle,
          product_url: productUrl,
          position: position,
          source_page_url: sourcePageUrl,
        });
        console.log("Event Tagged custom_search_click");
      }
    }
  });
});
